/* eslint-disable react/style-prop-object */
import React from "react";

export interface IconExampleProps {
  className?: string;
}
const IconPlay: React.FC<IconExampleProps> = ({ className = "" }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2600.000000 2600.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        Created by potrace 1.15, written by Peter Selinger 2001-2017
      </metadata>
      <g
        transform="translate(0.000000,2600.000000) scale(0.100000,-0.100000)"
        fill="#ffffff"
        stroke="none"
      >
        <path
          d="M12550 20993 c-1888 -82 -3625 -842 -4960 -2173 -1679 -1674 -2455
    -4024 -2104 -6374 370 -2477 2003 -4632 4296 -5669 832 -376 1682 -586 2621
    -648 233 -15 885 -6 1102 15 985 97 1869 352 2710 782 928 473 1750 1140 2416
    1959 917 1127 1491 2539 1623 3995 29 320 37 855 16 1155 -114 1655 -742 3173
    -1827 4417 -140 161 -443 468 -613 622 -1089 986 -2413 1615 -3870 1840 -435
    67 -980 98 -1410 79z m715 -1263 c848 -62 1627 -276 2365 -651 1712 -869 2925
    -2473 3289 -4349 36 -186 64 -384 88 -620 24 -247 24 -852 0 -1105 -80 -812
    -277 -1503 -633 -2215 -798 -1593 -2248 -2770 -3969 -3220 -315 -82 -660 -142
    -1020 -176 -220 -21 -818 -25 -1025 -6 -852 77 -1553 273 -2279 637 -1849 925
    -3120 2716 -3375 4755 -32 253 -37 342 -43 665 -6 335 3 537 32 805 188 1680
    1060 3207 2425 4245 457 347 1004 649 1546 853 556 209 1126 335 1729 381 160
    12 707 13 870 1z"
        />
        <path
          d="M11070 16155 c-146 -41 -256 -153 -294 -300 -14 -53 -16 -307 -16
    -2301 0 -2168 1 -2244 19 -2303 26 -82 60 -138 120 -195 61 -57 133 -91 219
    -105 67 -11 159 -1 217 23 18 8 900 515 1961 1127 1578 911 1938 1123 1980
    1164 166 166 160 437 -14 595 -43 40 -516 318 -1962 1153 -1048 605 -1932
    1111 -1964 1124 -76 32 -189 39 -266 18z"
        />
      </g>
    </svg>
  );
};

export default IconPlay;
